// client/src/main.tsx
import './polyfills' // Load polyfills first
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { installChunkLoadRecovery } from './utils/chunkRecovery'
import { installDomReconciliationGuard } from './utils/domReconciliationGuard'
import { initSentry } from './lib/sentry'
import './index.css'
import './i18n'
import { initializeDeviceDetection } from './utils/deviceDetection'
import { healthMonitor } from './services/healthMonitoring'
import { retryStrategy } from './services/retryStrategy'
import { analyticsCollector } from './services/analyticsCollector'
import { versionManager } from './services/versionManagement'
import { deploymentManager } from './services/deploymentManager'

// Initialize Sentry error tracking (must be first)
initSentry();

// Guard against page-translation/extension-induced removeChild/insertBefore
// crashes (DOMException code 8). Install before React renders. (Sentry NODE-CS)
installDomReconciliationGuard();

// Track basic page lifecycle for diagnostics (e.g. long-lived tabs)
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  const globalAny = window as any;
  const now = Date.now();

  if (typeof globalAny.__appStartTime !== 'number') {
    globalAny.__appStartTime = now;
  }
  if (typeof globalAny.__lastVisibilityChangeTimestamp !== 'number') {
    globalAny.__lastVisibilityChangeTimestamp = now;
  }
  globalAny.__visibilityState = document.visibilityState;

  document.addEventListener('visibilitychange', () => {
    const ts = Date.now();
    globalAny.__lastVisibilityChangeTimestamp = ts;
    globalAny.__visibilityState = document.visibilityState;
  });
}

// Initialize device detection and safe area handling
initializeDeviceDetection();

// Initialize enterprise error recovery services
healthMonitor.initialize();
retryStrategy.initialize();
analyticsCollector.initialize();
versionManager.initialize();
deploymentManager.initialize();
// Install auto-recovery for stale chunk/dynamic import failures
installChunkLoadRecovery();

// Initialize mobile layout debugger in development
if (process.env.NODE_ENV === 'development') {
  import('./utils/mobileLayoutDebug').then(() => {
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)